module.exports = "/_next/static/images/nile_mutton_curry-7451e6410ec0a610aa608fcaddf4e6d6.jpg";